import {
	Col,
	Row,
	Form,
	Divider,
	Space,
	Button,
	Input,
	Tooltip,
	Checkbox,
	Flex,
	Typography,
	Radio,
} from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { GET } from "../../../../providers/useAxiosQuery";

import dayjs from "dayjs";
import FloatInput from "../../../../providers/FloatInput";
import FloatInputMask from "../../../../providers/FloatInputMask";
import FloatSelect from "../../../../providers/FloatSelect";
import FloatDatePicker from "../../../../providers/FloatDatePicker";

import validateRules from "../../../../providers/validateRules";
import optionBloodType from "../../../../providers/optionBloodType";
import optionLanguage from "../../../../providers/optionLanguage";
import optionBirthPlace from "../../../../providers/optionBirthPlace";

export default function ApplicantFormBasicInfo(props) {
	const { form, dataCivilStatus, dataNationalities, dataReligion } = props;

	const location = useLocation();

	// Middle Name
	const [noMiddleName, setNoMiddleName] = useState(false);
	const handleMiddleName = (event) => {
		setNoMiddleName(event.target.checked);
		form.setFieldsValue({ middlename: "" });
	};

	useEffect(() => {
		if (!form.getFieldValue("middlename")) {
			setNoMiddleName(true);
			form.setFieldsValue({ middlename: "" });
		}
	}, [form]);

	// Add Language
	const [currentLanguage, setCurrentLanguage] = useState(optionLanguage);
	const [newLanguage, setNewLanguage] = useState("");

	const handleAddLanguage = () => {
		if (newLanguage) {
			setCurrentLanguage((prevOptions) => [
				...prevOptions,
				{ label: newLanguage, value: newLanguage },
			]);
			setNewLanguage("");
		}
	};

	// Add BirthPlace
	const [currentBirthPlace, setCurrentBirthPlace] = useState(optionBirthPlace);
	const [newBirthPlace, setNewBirthPlace] = useState("");

	const handleAddBirthPlace = () => {
		if (newBirthPlace) {
			setCurrentBirthPlace((prevOptions) => {
				const updatedOptions = [
					...prevOptions,
					{ label: newBirthPlace, value: newBirthPlace },
				];
				return updatedOptions.sort((a, b) => a.value.localeCompare(b.value));
			});
			setNewBirthPlace("");
		}
	};

	const { data: dataSchoolName } = GET(`api/school`, "school_list");

	// Last School Add Item
	const [currentSchoolList, setCurrentSchoolList] = useState([]);

	useEffect(() => {
		if (dataSchoolName && dataSchoolName.data) {
			const schoolList = dataSchoolName.data
				.filter((item) => item.school_level_id === 5)
				.map((item) => ({
					value: item.school_name,
					label: item.school_name,
				}))
				.sort((a, b) => a.label.localeCompare(b.label));
			setCurrentSchoolList(schoolList);
		}
	}, [dataSchoolName]);

	const [newSchoolList, setNewSchoolList] = useState("");

	const handleAddSchool = () => {
		if (newSchoolList) {
			setCurrentSchoolList((prevOptions) => [
				...prevOptions,
				{ label: newSchoolList, value: newSchoolList },
			]);
			setNewSchoolList("");
		}
	};

	return (
		<>
			<Row gutter={[12, 12]} className="basic-info">
				<Col xs={24} sm={12} md={12} lg={6} xl={6}>
					<Form.Item
						name="firstname"
						rules={[
							validateRules.required,
							validateRules.alphabet_symbol,
							validateRules.trim,
						]}
					>
						<FloatInput
							label="First Name"
							placeholder="First Name"
							required={true}
						/>
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={12} lg={6} xl={6}>
					<Flex gap={5}>
						<Col xs={20} sm={20} md={20} lg={18} xl={18} className="p-0">
							<Form.Item
								name="middlename"
								rules={[
									// if noMiddleName is true, then no need to validate required
									{
										required: !noMiddleName,
										message: "This field is required",
									},
									validateRules.alphabet,
									validateRules.trim,
								]}
								style={{ marginBottom: 0 }}
							>
								<FloatInput
									label="Middle Name"
									placeholder="Middle Name"
									required={true}
									disabled={noMiddleName}
								/>
							</Form.Item>
						</Col>
						<Flex vertical className="w-25">
							<Checkbox
								checked={noMiddleName}
								onChange={handleMiddleName}
								style={{ fontSize: "6px" }}
							></Checkbox>
							<p className="font-10px m-0">No Middle Name</p>
						</Flex>
					</Flex>
				</Col>

				<Col xs={24} sm={12} md={12} lg={6} xl={6}>
					<Form.Item
						name="lastname"
						rules={[
							validateRules.required,
							validateRules.alphabet,
							validateRules.trim,
						]}
					>
						<FloatInput
							label="Last Name"
							placeholder="Last Name"
							required={true}
						/>
					</Form.Item>
				</Col>

				<Col xs={24} sm={12} md={12} lg={6} xl={6}>
					<Form.Item
						name="name_ext"
						rules={[validateRules.alphabet_symbol, validateRules.name_suffix]}
					>
						<FloatInput label="Suffix" placeholder="Suffix" />
					</Form.Item>
				</Col>

				{!location.pathname.includes("/add") &&
				!location.pathname.includes("/profiling-portal") ? (
					<>
						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="birthplace" rules={[validateRules.address]}>
								<FloatSelect
									label="Place of Birth"
									placeholder="Place of Birth"
									allowClear
									options={currentBirthPlace}
									dropdownRender={(menu) => (
										<>
											{menu}
											<Divider
												style={{
													margin: "8px 0",
												}}
											/>
											<Space
												style={{
													padding: "0 8px 4px",
												}}
											>
												<Input
													style={{
														border: "1px solid",
													}}
													value={newBirthPlace}
													onChange={(e) => setNewBirthPlace(e.target.value)}
												/>
												<Button
													type="primary"
													icon={<FontAwesomeIcon icon={faPlus} />}
													name="btn-add-birthplace"
													onClick={handleAddBirthPlace}
												>
													Add Birth Place
												</Button>
											</Space>
										</>
									)}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item
								name="birthdate"
								rules={[
									{
										validator: (_, value) => {
											const today = dayjs();
											const birthdate = dayjs(value);
											const age = today.year() - birthdate.year();

											if (age < 3 || age > 110) {
												return Promise.reject(
													new Error("Age must be between 3 and 110")
												);
											}
											return Promise.resolve();
										},
									},
								]}
							>
								<FloatDatePicker
									className="birthdate"
									label="Date of Birth"
									placeholder="Date of Birth"
									allowClear
									onChange={(date) => {
										const today = dayjs();
										const birthDate = dayjs(date);
										let calculatedAge = today.diff(birthDate, "years");

										// Adjust the age if the birth date has not occurred yet this year
										if (today.isBefore(birthDate.add(calculatedAge, "years"))) {
											calculatedAge--;
										}

										form.setFieldsValue({ age: calculatedAge });
									}}
									format={{
										format: "MM-DD-YYYY",
										type: "mask",
									}}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Tooltip title="Please provide birthdate">
								<Form.Item name="age" rules={[validateRules.number]}>
									<FloatInput label="Age" placeholder="Age" disabled={true} />
								</Form.Item>
							</Tooltip>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="gender">
								<FloatSelect
									label="Sex"
									placeholder="Sex"
									options={[
										{
											label: "Male",
											value: "Male",
										},
										{
											label: "Female",
											value: "Female",
										},
									]}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="language">
								<FloatSelect
									label="Language"
									placeholder="Language"
									multi="multiple"
									allowClear
									options={currentLanguage}
									dropdownRender={(menu) => (
										<>
											{menu}
											<Divider
												style={{
													margin: "8px 0",
												}}
											/>
											<Space
												style={{
													padding: "0 8px 4px",
												}}
											>
												<Input
													style={{
														border: "1px solid",
													}}
													value={newLanguage}
													onChange={(e) => setNewLanguage(e.target.value)}
												/>
												<Button
													type="primary"
													icon={<FontAwesomeIcon icon={faPlus} />}
													name="btn-add-language"
													onClick={handleAddLanguage}
												>
													Add language
												</Button>
											</Space>
										</>
									)}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="blood_type">
								<FloatSelect
									allowClear
									label="Blood Type"
									placeholder="Blood Type"
									options={optionBloodType}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6} className="height-info">
							<Form.Item
								name="height"
								rules={[
									validateRules.height,
									{
										min: 2,
										max: 300,
									},
								]}
							>
								<FloatInputMask
									label="Height (cm)"
									placeholder="Height (cm)"
									maskType="999"
									autoComplete="off"
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6} className="weight-info">
							<Form.Item
								name="weight"
								rules={[
									validateRules.weight,
									{
										min: 2,
										max: 300,
									},
								]}
							>
								<FloatInputMask
									label="Weight (kg)"
									placeholder="Weight (kg)"
									maskType="99.9"
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="civil_status_id">
								<FloatSelect
									label="Civil Status"
									placeholder="Civil Status"
									allowClear
									options={dataCivilStatus
										.map((item) => ({
											value: item.id,
											label: item.civil_status,
										}))
										.sort((a, b) => a.label.localeCompare(b.label))}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="nationality_id">
								<FloatSelect
									label="Citizenship"
									placeholder="Citizenship"
									allowClear
									options={dataNationalities
										.map((item) => ({
											value: item.id,
											label: item.nationality,
										}))
										.sort((a, b) => a.label.localeCompare(b.label))}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={12} md={12} lg={6} xl={6}>
							<Form.Item name="religion_id">
								<FloatSelect
									label="Religion"
									placeholder="Religion"
									allowClear
									options={dataReligion
										.map((item) => ({
											value: item.id,
											label: item.religion,
										}))
										.sort((a, b) => a.label.localeCompare(b.label))}
								/>
							</Form.Item>
						</Col>
					</>
				) : null}

				<Col xs={24} sm={12} md={12} lg={6} xl={6} className="contact-info">
					<Form.Item
						name="contact_number"
						rules={[validateRules.phone, validateRules.required]}
					>
						<FloatInputMask
							label="Contact Number"
							placeholder="Contact Number"
							maskLabel="contact_number"
							required={true}
							maskType="(+63) 999 999 999"
						/>
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} lg={6} xl={6}>
					<Form.Item
						name="personal_email"
						rules={[validateRules.required, validateRules.email]}
					>
						<FloatInput label="Email" placeholder="Email" required />
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					{/* Last School Attended */}
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<Typography.Title level={5} className="m-0">
							Last School Attended
						</Typography.Title>

						<p className="mb-0">
							<strong>Note:</strong> If your school is not listed, please type
							the full name of your school without using abbreviations.{" "}
						</p>
					</Col>

					<Flex>
						{/* School Attended */}
						<Col xs={24} sm={24} md={24} lg={12} xl={12}>
							<Form.Item
								name="previous_school_name"
								rules={[validateRules.quillValidator]}
							>
								<FloatSelect
									label="Name of School"
									placeholder="Name of School"
									allowClear
									required={true}
									options={currentSchoolList}
									dropdownRender={(menu) => (
										<>
											{menu}
											<Divider
												style={{
													margin: "8px 0",
												}}
											/>
											<Flex
												style={{
													padding: "0 8px 4px",
												}}
												gap={12}
											>
												<Input
													style={{
														border: "1px solid",
														width: "100%",
													}}
													value={newSchoolList}
													onChange={(e) => setNewSchoolList(e.target.value)}
												/>
												<Button
													type="primary"
													icon={<FontAwesomeIcon icon={faPlus} />}
													name="btn-add-language"
													onClick={handleAddSchool}
												>
													Add School
												</Button>
											</Flex>
										</>
									)}
								/>
							</Form.Item>
						</Col>

						{/* Year Attended */}
						<Col xs={24} sm={24} md={24} lg={6} xl={6}>
							<Form.Item
								name="previous_school_year"
								rules={[validateRules.quillValidator]}
							>
								<FloatDatePicker
									label="Year Attended"
									placeholder="Year Attended"
									format="YYYY"
									picker="year"
									allowClear={true}
									required={true}
								/>
							</Form.Item>
						</Col>
					</Flex>

					{/* Applied to FSUU before */}
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<p className="mt-0">
							<Typography.Text type="danger">* </Typography.Text>Have you ever
							been enrolled in FATHER SATURNINO URIOS UNIVERSITY before?
						</p>

						<Flex>
							<Col xs={24} sm={24} md={8} lg={8} xl={8}>
								<Form.Item
									name="applied_to_fsuu"
									rules={[validateRules.required]}
								>
									<Radio.Group>
										<Radio value="Yes">Yes</Radio>
										<Radio value="No">No</Radio>
									</Radio.Group>
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={8} lg={8} xl={8}>
								<Form.Item shouldUpdate noStyle>
									{() => {
										let applied_to_fsuu = form.getFieldValue("applied_to_fsuu");

										if (applied_to_fsuu === "Yes") {
											return (
												<>
													<Form.Item
														name="year_applied"
														rules={[validateRules.quillValidator]}
													>
														<FloatDatePicker
															label="Year Applied"
															placeholder="Year Applied"
															format="YYYY"
															required={true}
															picker="year"
															allowClear={true}
														/>
													</Form.Item>
												</>
											);
										} else {
											return null;
										}
									}}
								</Form.Item>
							</Col>
						</Flex>

						<Form.Item shouldUpdate noStyle>
							{() => {
								let applied_to_fsuu = form.getFieldValue("applied_to_fsuu");

								if (applied_to_fsuu === "Yes") {
									return (
										<>
											<Col xs={24} sm={24} md={24} lg={24}>
												<p className="mt-0">Were you Accepted?</p>
											</Col>

											<Flex>
												<Col xs={24} sm={24} md={8} lg={8} xl={8}>
													<Form.Item name="accepted_to_fsuu">
														<Radio.Group>
															<Radio value="Yes">Yes</Radio>
															<Radio value="No">No</Radio>
														</Radio.Group>
													</Form.Item>
												</Col>

												<Form.Item shouldUpdate noStyle>
													{() => {
														let accepted_to_fsuu = form.getFieldValue(
															"accepted_to_fsuu"
														);

														if (accepted_to_fsuu === "Yes") {
															return (
																<>
																	<Col xs={24} sm={24} md={8} lg={8} xl={8}>
																		<Form.Item
																			name="year_accepted"
																			rules={[validateRules.quillValidator]}
																		>
																			<FloatDatePicker
																				label="Year Accepted"
																				placeholder="Year Accepted"
																				format="YYYY"
																				required={true}
																				picker="year"
																				allowClear={true}
																			/>
																		</Form.Item>
																	</Col>
																</>
															);
														}
													}}
												</Form.Item>
											</Flex>

											<Col
												xs={24}
												sm={24}
												md={24}
												lg={24}
												xl={24}
												className="mt-0"
											>
												<p className="mt-0">Did you attend?</p>
											</Col>

											<Col xs={24} sm={24} md={24} lg={24} xl={24}>
												<Row gutter={[12, 0]}>
													<Col xs={24} sm={24} md={8} lg={8} xl={8}>
														<Form.Item name="attended_to_fsuu" className="mb-0">
															<Radio.Group>
																<Radio value="Yes">Yes</Radio>
																<Radio value="No">No</Radio>
															</Radio.Group>
														</Form.Item>
													</Col>

													<Form.Item shouldUpdate noStyle>
														{() => {
															let attended_to_fsuu = form.getFieldValue(
																"attended_to_fsuu"
															);

															if (attended_to_fsuu === "Yes") {
																return (
																	<>
																		<Col xs={24} sm={24} md={8} lg={8} xl={8}>
																			<Form.Item
																				name="year_attended"
																				rules={[validateRules.quillValidator]}
																			>
																				<FloatDatePicker
																					label="Year Attended"
																					placeholder="Year Attended"
																					format="YYYY"
																					required={true}
																					picker="year"
																					allowClear={true}
																				/>
																			</Form.Item>
																		</Col>
																	</>
																);
															}
														}}
													</Form.Item>
												</Row>
											</Col>
										</>
									);
								} else {
									return null;
								}
							}}
						</Form.Item>
					</Col>

					{/* Scholarship */}
					{/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Typography.Title level={5} className="mt-0">
							Scholarship
						</Typography.Title>

						<p>
							<Typography.Text type="danger">* </Typography.Text>Do you intent
							to apply for a scholarship?
						</p>

						<Col xs={24} sm={24} md={24} lg={24} xl={24} className="ml-10">
							<Form.Item
								name="apply_scholarship"
								className="mb-0"
								rules={[validateRules.required]}
							>
								<Radio.Group>
									<Radio value="Yes">Yes</Radio>
									<Radio value="No">No</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
					</Col> */}
				</Col>
			</Row>
		</>
	);
}
